let ROOT_ELEMENT = () => {
    return document.querySelector("technology-radar").shadowRoot.getElementById("technology-radar")
}

module.exports = { ROOT_ELEMENT }